import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import RichTextEditor from 'react-rte';
import { AiOutlineDelete } from "react-icons/ai";
import Upload from '../Ui/Upload';
// import DropDown from '../Ui/DropDown';
import { getDocumentLabel } from '../../utils';
// import { toastMessage } from '../../utils/toast';
// import * as jobActions from '../../Redux/Actions/jobs';

const StatusModal = ({ t, showModal, status, documentArr, documentReason, jobId, handleDocumentReason, subjectOptions, subject, setSubject, comment, setComment, mailDocuments, setMailDocuments, loading, handleOk, handleCancel, footerOption1, footerOption2 }) => {

    // const [attachmentID, setAttachmentID] = useState('');
    // const [attachmentName, setAttachmentName] = useState('');
    // const [uploadLoading, setUploadLoading] = useState(false);

    const toolbarConfig = {
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
          {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
          {label: 'Italic', style: 'ITALIC'},
          {label: 'Underline', style: 'UNDERLINE'}
        ],
        BLOCK_TYPE_BUTTONS: [
          {label: 'UL', style: 'unordered-list-item'},
          {label: 'OL', style: 'ordered-list-item'}
        ]
    };
    
    const documentReasonList = [
        {label: t("jobsManagement.infoJob.jobStatus.imageNotClear"), value: t("jobsManagement.infoJob.jobStatus.imageNotClear")},
        {label: t("jobsManagement.infoJob.jobStatus.documentExpired"), value: t("jobsManagement.infoJob.jobStatus.documentExpired")}
    ];

    // const handleUploadPaymentReceipt = (files) => {
    //     setUploadLoading(true);
    //     let data = new FormData();
    //     data.append('jobId', jobId);
    //     data.append('tag', 'jobs');
    //     setAttachmentName((files.length === 1) ? files[0].name : `${files.length} files selected`);
        
    //     for(let i=0; i <= files.length; i++) {
    //         if(files[i] !== undefined) {
    //             data.append('file', files[i]);
    //             let woExtensionName = files[i] && files[i].name.split('.');
    //             data.append('extension', '.' + woExtensionName[1]);
    //         }
    //     }

    //     jobActions.uploadPaymentReceipt(data).then(res => {
    //         if(res && res.data){
    //             setUploadLoading(false);
    //             setAttachmentID(res.data);
    //         }
    //     }).catch(err => {
    //         toastMessage('error', (err && err.message) || `Unable to upload the document`);
    //     });
    // };

    const handleDisableSubmitCTA = () => {
        if (status === 'AwaitingResponse') {
            // return loading || (Object.keys(documentReason).length === 0)
        } else if (status === 'EmailDocuments') {
            // return loading || (subject === '') || (comment.toString('html') === '<p><br></p>') || (mailDocuments.length === 0)
            return loading || (mailDocuments.length === 0)
        } else {
            // return (!attachmentID || (comment.toString('html') === '<p><br></p>'))
            return (comment.toString('html') === '<p><br></p>')
        }
    };
    
    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.jobStatus.title")} - {status}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            {(status === 'EmailDocuments') ? <div>
                                {/* <div className="my-2 mb-3">
                                    <p className="mb-1">{t("jobsManagement.infoJob.jobStatus.subject")}*</p>
                                    <DropDown value={subject} placeholder={t("jobsManagement.infoJob.jobStatus.subjectPlaceholder")} options={subjectOptions} onChange={e => setSubject(e)} />
                                </div>
                                <div className="my-2 mb-3">
                                    <p className="mb-1">{t("jobsManagement.infoJob.jobStatus.comment")}*</p>
                                    <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={comment} onChange={value => setComment(value)} />
                                </div> */}
                                <div className="my-2 mb-3">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.jobStatus.attachments")}*</label>
                                    <div className="d-flex align-items-center">
                                        <Upload selectedFiles={mailDocuments} multiple={true} onChange={e => setMailDocuments(e.target.files)} />
                                        {(mailDocuments.length !== 0) && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => setMailDocuments([])} />}
                                    </div>
                                </div>
                            </div>
                            : ((status === 'AwaitingResponse') ? <div className="d-flex flex-column">
                                    {documentArr.map(({key, documentId}, id) => <div className="my-2" key={id} onChange={(e) => handleDocumentReason(key, e.target.value)}>
                                        <p className="mb-1">{getDocumentLabel(key)}</p>
                                        <select className="form-select status_change" value={(documentReason[key] === undefined) ? "" : documentReason[key]}>
                                            <option value="">{t("jobsManagement.infoJob.jobStatus.documentOk")}</option>
                                            {documentReasonList.map(({label, value}) => <option key={value} value={value}>{label}</option>)}
                                        </select>
                                    </div>)}
                                    <div className="d-none">
                                        <ul id="reasonList">
                                            {Object.entries(documentReason).map(([key, value]) =>
                                                (value !== '') && <li key={key}>{getDocumentLabel(key)}: {value}</li>
                                            )}
                                        </ul>
                                    </div>
                                    <div className="my-2">
                                        <p className="mb-1">{t("jobsManagement.infoJob.jobStatus.comment")}*</p>
                                        <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={comment} onChange={value => setComment(value)} />
                                    </div>
                                </div> 
                            : <div>
                                {/* <div className="my-2 mb-3">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.jobStatus.attachments")}*</label>
                                    <div className="d-flex align-items-center">
                                        <Upload loading={uploadLoading} selectedFiles={attachmentName} multiple={true} onChange={e => handleUploadPaymentReceipt(e.target.files)} />
                                        {(attachmentName || attachmentID) && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() =>{ setAttachmentID(''); setAttachmentName('')}} />}
                                    </div>
                                </div> */}
                                <div className="my-2">
                                    <p className="mb-1">{t("jobsManagement.infoJob.jobStatus.comment")}*</p>
                                    <RichTextEditor className="textEditor mb-6" toolbarConfig={toolbarConfig} value={comment} onChange={value => setComment(value)} />
                                </div>
                            </div>)}
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={loading} className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : t("jobsManagement.infoJob.jobStatus.close")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || handleDisableSubmitCTA()} onClick={() => handleOk()}>{footerOption1 ? footerOption1 : t("jobsManagement.infoJob.jobStatus.ok")}
                                {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default StatusModal;